import numbro from 'numbro';


const currency = (val, separate) => {
  const separateThousands = typeof separate === 'boolean' ? separate : true;
  return numbro(val).format({ thousandSeparated: separateThousands, mantissa: 0 });
};


const currencySum = (list) => {
  const getNumbro = val => numbro(val || 0);

  let total = 0;
  list.forEach((val) => {
    total += getNumbro(val);
  });

  return currency(total);
};


const formatBytes = (bytes, decimals) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals <= 0 ? 0 : decimals || 2;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const result = parseFloat((bytes / (k ** i)).toFixed(dm)).toString();
  return `${result}  ${sizes[i]}`;
};


const toValuesStr = (value) => {
  if (!value) { return ''; }

  if (value instanceof Object) {
    return Object.keys(value).map(key => toValuesStr(value[key])).join(' ');
  }

  return String(value);
};

let decoderElement = null;
const decodeHtml = (html) => {
  /*
  Decodes a html in similar way as Vue does to escape html.
  */
  decoderElement = decoderElement || document.createElement('div');
  decoderElement.innerHTML = html;
  return decoderElement.textContent;
};

export default {
  map: (source, origin, add) => {
    /* eslint no-param-reassign: ["error", { "props": false }] */
    const addFields = add || false;

    Object.keys(source).forEach((key) => {
      const keyValue = source[key];
      if (keyValue && (Object.prototype.hasOwnProperty.call(origin, key) || addFields)) {
        origin[key] = keyValue;
      }
    });
  },

  clear: (data) => {
    /* eslint no-param-reassign: ["error", { "props": false }] */
    Object.keys(data).forEach((key) => {
      data[key] = (typeof data[key] === 'object' && data[key] !== null) ? {} : null;
    });
  },

  capitalizeWord: str => str.charAt(0).toUpperCase() + str.slice(1),
  checkProp: (data, key) => Object.prototype.hasOwnProperty.call(data, key),

  isEmpty: (obj) => {
    if (obj.constructor === Object) {
      return Object.keys(obj).every(key => (obj[key] === null || obj[key] === undefined));
    } else if (Array.isArray(obj)) {
      return !obj.length;
    }

    return false;
  },

  copy: obj => JSON.parse(JSON.stringify(obj)),

  readableBool: val => (val ? 'Yes' : 'No'),

  currency,
  currencySum,

  phoneMask: str => (str ? str.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3') : ''),

  camelToSnake: str => (str ? str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`) : ''),
  formatBytes,

  formatDate: (value) => {
    if (!value) { return ''; }

    try {
      const date = new Date(value.replace('GMT', ''));
      const zeroed = val => (val < 10 ? `0${val}` : val);
      return date.toLocaleDateString('en-US').split('/').map(val => zeroed(val)).join('/');
    } catch (error) {
      return value;
    }
  },

  formatDateTime: (value) => {
    let result = '';
    let date;
    if (!value) return result;
    try {
      date = new Date(value);
      result = date.toLocaleDateString('en-US');
      result = `${result} ${date.toLocaleTimeString('en-US')}`;
    } catch (error) {
      result = 'error';
    }

    return result;
  },

  dayDiff: (date1, date2) => {
    const diffTime = Math.abs(date1.getTime() - date2.getTime());
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  },

  toValuesStr,
  redBadgeTitle: fileList => (
    fileList.length === 0 ?
      'Needed files' :
      'Reviewed - Please contact your processor.'
  ),

  decodeHtml,
};



// WEBPACK FOOTER //
// ./src/libs/helper.js